import styled from 'styled-components'
import { Store, shoppingStores } from '@/features/shared/constants/stores'
import { Headline } from '@shipt/design-system-typography'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { shadow1 } from '@/features/shared/styles/effects'
import { spacing } from '@/features/shared/theme/tokens'
import { NextLink } from '@/features/shared/elements/Link'

export const StoreShowcase = () => {
  const staticRetailers = [
    shoppingStores[Store.Cvs],
    shoppingStores[Store.Heb],
    shoppingStores[Store.Lowes],
    shoppingStores[Store.Meijer],
    shoppingStores[Store.OfficeDepot],
    shoppingStores[Store.Petco],
    shoppingStores[Store.Target],
    shoppingStores[Store.Walgreens],
    shoppingStores[Store.HyVee],
  ]

  return (
    <Wrapper>
      <Title as="h2" size="md">
        Get same-day delivery from stores you know and love.
      </Title>
      <StoreWrapper>
        {staticRetailers.map(({ name, circular_image, url }) => (
          <NextLink key={name} href={url}>
            <Image
              key={name}
              src={circular_image}
              alt={`Get same-day delivery from ${name} with Shipt`}
              width={48}
              height={48}
            />
          </NextLink>
        ))}
      </StoreWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.gray50};
  border-radius: 8px;
  padding: 1rem;
  ${shadow1};
`

const Title = styled(Headline)`
  margin-bottom: ${spacing('lg')};
`

const StoreWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 48px);
  gap: ${spacing('lg')};
  justify-content: space-between;
`
